import React from "react";
import NumberInput from "../../../../common/NumberInput";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

class Assolement extends React.Component {
  render() {
    const {
      indicateur,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
      getValueAssolement,
      displayRules,
      fixedDecimalScale,
      showValueN_1N_2,
      hide = false,
    } = this.props;

    const isColumnDisplay = displayRules?.displayAssolement === "column";
    const isAssolementOnly = displayRules?.displayAssolement === "assolementOnly" ? true : false;

    const valueRendered = (
      <React.Fragment>
        <NumberInput
          size={this.props.size}
          disabled
          fullWidth={false}
          style={{ width: "8rem" }}
          label={"Valeur assolement"}
          value={getValueAssolement(indicateur?.codeNational) ?? ""}
          InputProps={valueInputProps}
          fixedDecimalScale={fixedDecimalScale}
        />
        {!isAssolementOnly && (
          <>
            {!hide && (
              <NumberInput
                helperText={this.props.helperText}
                error={this.props.error}
                className={isColumnDisplay ? "mt-1" : "ml-2"}
                fullWidth={false}
                style={{ width: "8rem" }}
                size={this.props.size}
                value={indicateur?.valeur.value ?? ""}
                InputLabelProps={{
                  style: { fontWeight: indicateur?.afficherGras ? "bold" : "normal" },
                }}
                InputProps={valueInputProps}
                disabled={computedFields.includes(indicateur?.codeNational) || this.props.disabled}
                fixedDecimalScale={fixedDecimalScale}
                onChange={(newValeur) =>
                  changeIndicateur(
                    {
                      ...indicateur,
                      valeur: {
                        ...indicateur.valeur,
                        value: newValeur === "" ? null : Number(newValeur),
                      },
                    },
                    sousRubriqueIndex,
                    libelleEnglobantIndex
                  )
                }
              />
            )}
            <div className={"d-flex"}>
              {showValueN_1N_2 && (
                <React.Fragment>
                  {!hide && (
                    <>
                      <NumberInput
                        helperText={this.props.helperText}
                        error={this.props.error}
                        className={isColumnDisplay ? "mt-1" : "ml-2"}
                        fullWidth={false}
                        style={{ width: "8rem" }}
                        size={this.props.size}
                        value={indicateur?.valeur.value_N_1 ?? ""}
                        InputLabelProps={{
                          style: { fontWeight: indicateur?.afficherGras ? "bold" : "normal" },
                        }}
                        InputProps={valueInputProps}
                        fixedDecimalScale={fixedDecimalScale}
                        disabled={computedFields.includes(indicateur?.codeNational) || this.props.disabled}
                        onChange={(newValeur) =>
                          changeIndicateur(
                            {
                              ...indicateur,
                              valeur: {
                                ...indicateur.valeur,
                                value_N_1: newValeur === "" ? null : Number(newValeur),
                              },
                            },
                            sousRubriqueIndex,
                            libelleEnglobantIndex
                          )
                        }
                      />
                      <NumberInput
                        helperText={this.props.helperText}
                        error={this.props.error}
                        className={isColumnDisplay ? "mt-1" : "ml-2"}
                        fullWidth={false}
                        style={{ width: "8rem", visibility: hide ? "hidden" : "visible" }}
                        size={this.props.size}
                        value={indicateur?.valeur.value_N_2 ?? ""}
                        fixedDecimalScale={fixedDecimalScale}
                        InputLabelProps={{
                          style: { fontWeight: indicateur?.afficherGras ? "bold" : "normal" },
                        }}
                        InputProps={valueInputProps}
                        disabled={computedFields.includes(indicateur?.codeNational) || this.props.disabled}
                        onChange={(newValeur) =>
                          changeIndicateur(
                            {
                              ...indicateur,
                              valeur: {
                                ...indicateur.valeur,
                                value_N_2: newValeur === "" ? null : Number(newValeur),
                              },
                            },
                            sousRubriqueIndex,
                            libelleEnglobantIndex
                          )
                        }
                      />
                    </>
                  )}
                </React.Fragment>
              )}
            </div>
          </>
        )}
      </React.Fragment>
    );

    return <div className={isColumnDisplay ? "d-flex flex-column align-items-center" : "d-flex "}>{valueRendered}</div>;
  }
}

export default compose(withTranslation())(Assolement);
